module.exports = __webpack_public_path__ + "img/1_en.0e91e115.webp";